import React from "react";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";

const _ModalDeleteRCSAgent = (props) => {
  const {
    visible = false,
    onClose,
    title = "",
    description = "",
    onDelete,
    isLoading = false,
  } = props;

  const _onClose = () => {
    if (onClose) onClose();
  };

  return (
    <Modal show={visible} onHide={_onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{description}</p>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-danger"
          onClick={onDelete}
          loading={isLoading}
          disabled={isLoading}
        >
          Aceptar
        </button>
        <button
          className="btn btn-secondary"
          onClick={_onClose}
          loading={isLoading}
          disabled={isLoading}
        >
          Cancelar
        </button>
      </Modal.Footer>
    </Modal>
  );
};
_ModalDeleteRCSAgent.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  onDelete: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default _ModalDeleteRCSAgent;
